var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.460905 8.13664C0.459583 7.74123 0.634472 7.36647 0.936577 7.11735L8.65017 0.805579C9.12456 0.409208 9.8085 0.409208 10.2829 0.805579L17.9965 7.33951C18.5432 7.80141 18.618 8.62635 18.1636 9.18207C17.7092 9.7378 16.8976 9.81386 16.3509 9.35196L9.4601 3.51062L2.56929 9.15594C2.18397 9.48223 1.64715 9.55098 1.19424 9.33202C0.741344 9.11307 0.455048 8.64639 0.460905 8.13664Z",
    fill: "#8DB6CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand-more.3787771b963221b864ec154c84e9f1a0.svg";
export { ForwardRef as ReactComponent };